export default __webpack_public_path__ + "d45ecd8b7149ea8b0210205c8d05991f.png";